import React, { useState } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import './App.css';

const searchUrls = [
  "https://hook.us1.make.com/dnqlpfxag5rzl4daad5bxk1red28mhd3",
  "https://hook.us2.make.com/9046agmbe07qp1nx5z350s1bjfykegik",
  "https://hook.us2.make.com/aldwr11r3eputvoaozvr9cge51y9iasm",
];

const downloadUrls = [
  "https://hook.us1.make.com/23599xcub5i67pdb2jlnul9nxonhr1yb",
  "https://hook.us2.make.com/gkq0abl5nbgntgfugg2w8wfmwso1jf83",
  "https://hook.us2.make.com/wpt2zs7w7u30g2d0r4gfx2nrid23qmj9"
];

// Función mejorada para búsqueda con fallback automático
const searchWithFallback = async (type, number) => {
  for (let i = 0; i < searchUrls.length; i++) {
    try {
      const url = `${searchUrls[i]}?type_id=${type}&number=${number}`;
      console.log(`Intentando búsqueda con URL ${i + 1}:`, url);
      
      const response = await axios.get(url, { timeout: 10000 });
      
      // Si la respuesta es "Accepted", intentar con la siguiente URL
      if (response.data === "Accepted" && i < searchUrls.length - 1) {
        console.log(`URL ${i + 1} devolvió "Accepted", intentando con siguiente URL...`);
        continue;
      }
      
      console.log(`Búsqueda exitosa con URL ${i + 1}`);
      return response.data;
    } catch (error) {
      console.error(`Error con URL de búsqueda ${i + 1}:`, error.message);
      
      // Si es la última URL, lanzar el error
      if (i === searchUrls.length - 1) {
        throw new Error('Todas las URLs de búsqueda fallaron');
      }
      
      // Si no es la última, continuar con la siguiente
      console.log(`Intentando con la siguiente URL de búsqueda...`);
    }
  }
};

// Función mejorada para descarga con fallback automático
const downloadWithFallback = async (name) => {
  for (let i = 0; i < downloadUrls.length; i++) {
    try {
      const url = `${downloadUrls[i]}?name=${name}`;
      console.log(`Intentando descarga con URL ${i + 1}:`, url);
      
      const response = await axios.get(url, { timeout: 10000 });
      
      // Si la respuesta es "Accepted", intentar con la siguiente URL
      if (response.data === "Accepted" && i < downloadUrls.length - 1) {
        console.log(`URL ${i + 1} devolvió "Accepted", intentando con siguiente URL...`);
        continue;
      }
      
      console.log(`Descarga exitosa con URL ${i + 1}`);
      return url;
    } catch (error) {
      console.error(`Error con URL de descarga ${i + 1}:`, error.message);
      
      // Si es la última URL, devolver la primera como fallback final
      if (i === downloadUrls.length - 1) {
        console.log('Todas las URLs fallaron, usando primera URL como último recurso');
        return `${downloadUrls[0]}?name=${name}`;
      }
      
      // Si no es la última, continuar con la siguiente
      console.log(`Intentando con la siguiente URL de descarga...`);
    }
  }
};

const App = () => {
  const [documentType, setDocumentType] = useState('');
  const [documentNumber, setDocumentNumber] = useState('');
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [captchaValid, setCaptchaValid] = useState(false);

  const handleRecaptchaChange = (value) => {
    if (value) {
      setCaptchaValid(true);
    } else {
      setCaptchaValid(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!documentType || !documentNumber) {
      setError('Por favor, completa todos los campos.');
      return;
    }

    if (!captchaValid) {
      alert('Por favor, completa el reCAPTCHA.');
      return;
    }

    setLoading(true);
    setError('');
    setCertificates([]);

    try {
      const data = await searchWithFallback(documentType, documentNumber);
      
      if (!data || data.length === 0 || data.some(cert => cert.name === null)) {
        setCertificates([]);
        setError(
          <>
            No se encontraron certificados para el documento {documentNumber}, para más información clic <strong><a href="https://drive.google.com/file/d/1teuUr91ADMHbnGmliinyuV-pD6va-RtJ/view?usp=sharing" target="_blank" rel="noopener noreferrer" style={{ color: 'red', textDecoration: 'none' }}>aquí</a></strong>.
          </>
        );
      } else {
        setCertificates(data);
        setError('');
      }
    } catch (error) {
      console.error('Error fetching the certificates:', error);
      setError('Error al consultar los certificados. Por favor, intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (certificateName) => {
    try {
      const url = await downloadWithFallback(certificateName);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error al obtener URL de descarga:', error);
      alert('Error al descargar el certificado. Por favor, intenta nuevamente.');
    }
  };

  return (
    <div className="container">    
      <nav className="navbar">
        <img src="logo-mision.png" alt="Left" className="navbar-left" />
        <img src="logo-utp.png" alt="Right" className="navbar-right" />
      </nav><br></br>
      <div className="content">
        <div className="left-panel">
          <h2 className="title">Consulta tus certificados</h2>
          <p className="subtitle">Ingrese su número de documento.</p>
          <img src='personaje.png' alt="Ilustración de personaje" className="image" />
        </div>
        <div className="right-panel">
          <div className='inputs-container'>
            <form onSubmit={handleSubmit} className="form">
              <select
                value={documentType}
                onChange={(e) => setDocumentType(e.target.value)}
                className="input same-width"
              >
                <option value="" disabled>Tipo de Documento</option>
                <option value="ti">T.I (Tarjeta de Identidad)</option>
                <option value="cc">C.C (Cédula de Ciudadanía)</option>
                <option value="ce">C.E (Cédula de Extranjería)</option>
                <option value="pep">PEP (Pasaporte)</option>
                <option value="nes">NES (Número de Estudiante)</option>
              </select>
              
              <input
                type="text"
                value={documentNumber}
                onChange={(e) => setDocumentNumber(e.target.value)}
                placeholder="Documento identidad estudiante"
                className="input same-width"
              />

              <ReCAPTCHA
                sitekey="6LfB_CQqAAAAAGXyZqVmq3bXq40kW7FCvnKmkorb"
                onChange={handleRecaptchaChange}
              />
              <button 
                type="submit" 
                className="button"
              >Consultar</button>
            </form>
          </div>
        </div>
      </div>
      <div className="instructions">
        <a
          href={`${process.env.PUBLIC_URL}/manual.pdf`}
          target="_blank"
          rel="noopener noreferrer"
          className="instructions-link"
        >
          Clic acá para ver las instrucciones
        </a>
      </div>

      {loading && <p>Cargando...</p>}
      {error && <p className="error">{error}</p>}
      {certificates.length > 0 && (
        <div className="certificates-section">
          <h3 className="certificates-title">Tienes los siguientes certificados</h3>
          <div className="certificates">
            {certificates.map((certificate, index) => (
              <div key={index} className="certificate-card">
                <img src="2912780.png" alt={`Certificado ${index + 1}`} className="certificate-image" />
                <div>
                  <span className="certificate-name">Certificado {index + 1}</span>
                  <button
                    type="button"
                    className="certificate-link-button download-link"
                    onClick={(e) => {
                      handleDownload(certificate.name);
                    }}
                  >
                    Descargar
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="footer">
        <p>¿Tienes problemas? <b><a className="link" target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1teuUr91ADMHbnGmliinyuV-pD6va-RtJ/view?usp=sharing">Solicita tu certificado en nuestra mesa de ayuda - revisa el tutorial</a></b></p>
      </div>
    </div>
  );
};

export default App;